import type { ApiError } from '@porotutu/react/errors'

export function unwrap<T>({ data, error }: { data: T | null; error: ApiError | null }): T {
  if (error !== null) throw error

  if (data === null) throw new Error('the api answered with no body')

  return data
}
